import { Component, inject } from '@angular/core';

import { PageForbiddenService } from '@core/services/page-forbidden.service';

/** Toast-like notice at the bottom of the screen: "Keine Berechtigung für diese Aktion." Dismisses itself. */
@Component({
  selector: 'app-page-forbidden-notice',
  template: `
    @if (notice.visible()) {
      <div class="page-forbidden-notice card card-elevated" role="alert">
        <span>Keine Berechtigung für diese Aktion. Wenden Sie sich an eine Administratorin oder einen Administrator.</span>
        <button type="button" class="btn-outline btn-sm" (click)="notice.dismiss()">Schliessen</button>
      </div>
    }
  `,
  styles: `
    .page-forbidden-notice {
      position: fixed;
      left: 50%;
      bottom: var(--s-6);
      transform: translateX(-50%);
      z-index: 1900;
      display: flex;
      align-items: center;
      gap: var(--s-4);
      max-width: min(560px, calc(100vw - 2 * var(--s-4)));
      padding: var(--s-3) var(--s-4);
      border-left: 4px solid var(--color-error);
    }
  `,
})
export class PageForbiddenNotice {
  protected readonly notice = inject(PageForbiddenService);
}
